import Phaser from 'phaser';
import { computeSystemChecks, SystemCheckResult } from '../utils/systemCheck';

export class SystemCheckScene extends Phaser.Scene {
  private lines: Phaser.GameObjects.Text[] = [];
  private checks: SystemCheckResult[] = [];
  private started: boolean = false;
  private autoAdvanceTimer?: Phaser.Time.TimerEvent;
  private gamepad: Phaser.Input.Gamepad.Gamepad | null = null;
  private prevButtonPressed: boolean = false;

  constructor() {
    super({ key: 'SystemCheckScene' });
  }

  create(): void {
    // Reset state for scene reuse
    this.started = false;
    this.prevButtonPressed = false;
    this.gamepad = null;
    this.lines = [];
    this.checks = [];
    
    const { width } = this.scale;
    this.cameras.main.setBackgroundColor(0x000000);

    this.add.text(width / 2, 60, 'SYSTEM BOOT - PACSHIP', {
      fontFamily: 'Courier New',
      fontSize: '26px',
      color: '#00ff00'
    }).setOrigin(0.5);

    const subtitle = this.add.text(width / 2, 90, 'Running diagnostics...', {
      fontFamily: 'Courier New',
      fontSize: '18px',
      color: '#88ff88'
    }).setOrigin(0.5);

    const lsAvailable = true; // computed inside helper by default
    const faceCount = undefined;
    const gamepadTotal = this.input.gamepad?.total ?? 0;
    this.checks = computeSystemChecks({
      localStorageAvailable: lsAvailable,
      faceCountOverride: faceCount,
      gamepadTotal
    });

    const startY = 160;
    this.checks.forEach((check, i) => {
      const line = this.add.text(80, startY + i * 36, `> ${check.label}: ...`, {
        fontFamily: 'Courier New',
        fontSize: '20px',
        color: '#00ff00'
      }).setAlpha(0);
      this.lines.push(line);

      this.time.delayedCall(300 + i * 400, () => {
        const color =
          check.status === 'ok' ? '#00ff00' : check.status === 'warn' ? '#ffff00' : '#ff4444';
        line.setText(`> ${check.label}: ${check.detail}`);
        line.setColor(color);
        line.setAlpha(1);
      });
    });

    subtitle.setAlpha(0.8);

    const advance = () => this.advance();
    this.input.once('pointerdown', advance);
    this.input.keyboard?.once('keydown', advance);

    // Initialize gamepad if connected
    if (this.input.gamepad && this.input.gamepad.total > 0) {
      this.gamepad = this.input.gamepad.getPad(0);
      if (this.gamepad) {
        this.prevButtonPressed = this.gamepad.A || this.gamepad.buttons[0]?.pressed || false;
      }
    }
    this.input.gamepad?.on('connected', (pad: Phaser.Input.Gamepad.Gamepad) => {
      this.gamepad = pad;
    });

    const totalDuration = 300 + this.checks.length * 400 + 800;
    this.autoAdvanceTimer = this.time.delayedCall(totalDuration, advance);
  }

  update(): void {
    if (!this.gamepad || !this.gamepad.connected) {
      if (this.input.gamepad && this.input.gamepad.total > 0) {
        this.gamepad = this.input.gamepad.getPad(0);
      }
    }
    
    if (this.gamepad && this.gamepad.connected) {
      const isPressed = this.gamepad.A || this.gamepad.buttons[0]?.pressed || false;
      if (isPressed && !this.prevButtonPressed) {
        this.advance();
      }
      this.prevButtonPressed = isPressed;
    }
  }

  private advance(): void {
    if (this.started) return;
    this.started = true;
    this.autoAdvanceTimer?.remove(false);
    this.scene.start('MenuScene');
  }
}
